<template>
    <div v-if="player">
        <!-- deposit / withdraw -->
        <section class="accordions">
            <article class="accordion"
                     :class="{'is-active': balanceOperationVisible}">
                <div class="accordion-header toggle is-size-5"
                     @click="balanceOperationVisible = !balanceOperationVisible">
                    <a>Deposit / Withdraw balance ⯆</a>
                </div>
                <div class="accordion-body">
                    <div class="accordion-content has-background-dark has-text-white">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Balance</label>
                            </div>
                            <div class="field-body">
                                <div class="field is-grouped">
                                    <div class="control">
                                        <div class="select">
                                            <select v-model="targetBalance">
                                                <option v-for="balance in player.balances"
                                                        :value="balance">
                                                    {{balance.real | currency(balance.currency)}}
                                                    <description :obj="balance" />
                                                    <span v-if="balance.isActive">[active]</span>
                                                </option>
                                            </select>
                                            <p class="help is-danger"
                                               v-if="!$v.targetBalance.required">Choose target balance</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="field">
                                    <p class="control">
                                        <input class="input"
                                               type="number"
                                               placeholder="Amount"
                                               v-model="transferAmount">
                                    </p>
                                    <p class="help is-danger"
                                       v-if="!$v.transferAmount.required">Enter amount</p>
                                    <p class="help is-danger"
                                       v-if="!$v.transferAmount.minValue">Min amount is 0.01</p>
                                </div>
                                <div class="field is-grouped">
                                    <p class="control">
                                        <button class="button is-link"
                                                @click="deposit()"
                                                :disabled="$v.$invalid">Deposit</button>
                                    </p>
                                    <p class="control">
                                        <button class="button is-danger"
                                                @click="withdraw()"
                                                :disabled="$v.$invalid || getSourceTransferAmount() > targetBalance.real">Withdraw</button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>

        <!-- filters -->

        <!-- list -->
        <transactions-list :data-func="getTransactions"
                           :show-user="false" />
    </div>
</template>
<script>
import state from "../../../../../state";
import playerService from "../../../../../services/player.service";
import transactionService from "../../../../../services/transaction.service";
import balanceService from "../../../../../services/balance.service";
import currencyService from "../../../../../services/currency.service";

import description from "../../../../common/description.vue";
import transactionsList from "../../../../common/transactions-list.vue";

import { required, minValue } from "vuelidate/lib/validators";

export default {
    name: "player-transactions",
    components: { description, transactionsList },
    data() {
        return {
            targetBalance: null,
            transferAmount: 0,
            balanceOperationVisible: false
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        playerId() {
            return this.$route.params.playerId;
        },
        player() {
            return state.editPlayer.get();
        }
    },
    validations: {
        targetBalance: {
            required
        },
        transferAmount: {
            required,
            minValue: minValue(0.01)
        }
    },
    async mounted() {
        await playerService.load(this.playerId);
    },
    methods: {
        async getTransactions(filter) {
            filter.clientId = this.clientId;
            filter.userId = this.playerId;
            return await transactionService.get(filter);
        },
        async deposit() {
            await this.transfer(balanceService.depositUser);
        },
        async withdraw() {
            await this.transfer(balanceService.withdrawUser);
        },
        async transfer(transferFunc) {
            await transferFunc(
                this.targetBalance.id,
                await this.getSourceTransferAmount(),
                this.targetBalance.currency
            );
            await this.loadTransactions();
            this.targetBalance = null;
            this.transferAmount = 0;
        },
        getSourceTransferAmount() {
            return this.targetBalance
                ? currencyService.toSource(
                      this.transferAmount,
                      this.targetBalance.currency
                  )
                : 0;
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/players/player/transactions.vue